module.exports = __webpack_public_path__ + "static/img/4.c818741.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/sp/4.png
// module id = j1fj
// module chunks = 0